import { usePermissions } from "@/hooks/use-permissions";
import { useLocation } from "wouter";
import { useEffect, type ReactNode } from "react";

interface PermissionGuardProps {
  permissionKey: string;
  children: ReactNode;
}

export function PermissionGuard({ permissionKey, children }: PermissionGuardProps) {
  const { hasPermission, isLoading } = usePermissions();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!isLoading && !hasPermission(permissionKey)) {
      setLocation('/');
    }
  }, [isLoading, permissionKey]);

  if (isLoading) return null;
  if (!hasPermission(permissionKey)) return null;
  return <>{children}</>;
}
